/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_ExternalInputs */

const cs_api_error_external = /** @type {(inputs: Api_Error_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externí služba selhala. Zkuste to za chvíli.`)
};

const en_api_error_external = /** @type {(inputs: Api_Error_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An external service failed. Try again in a moment.`)
};

/**
* | output |
* | --- |
* | "An external service failed. Try again in a moment." |
*
* @param {Api_Error_ExternalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_external = /** @type {((inputs?: Api_Error_ExternalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_ExternalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_external(inputs)
	return cs_api_error_external(inputs)
});